import React, { useEffect, useState } from 'react';
import Grid from '@mui/material/Grid2';
import AppAnimate from '../../components/AppAnimate';
import { useSnackbar } from 'notistack';
import axios from 'axios';
import { defaultVariables } from '../../../config';
import ItemsSkeleton from '../../components/loaders/ItemsSkeleton';
import { useTranslation } from 'react-i18next';
import InfiniteScroll from 'react-infinite-scroll-component';
import {CircularProgress, Divider} from '@mui/material';
import Title from '../../components/elements/Title';
import { scrollTop } from '../../../config/values';
import NothingFound from "../../components/elements/NothingFound";
import {ChevronLeft, ClipboardList, Headset, MessageSquareOff, RefreshCw} from "lucide-react";
import Button from "@mui/material/Button";
import {Link} from "react-router-dom";
import SubTitle from "../../components/elements/SubTitle";
import MyWallet from "../../components/elements/MyWallet";
import ListFilters from "../manage/lists/filters/ListFilters";
import SingleTicketListItem from "./SingleTicketListItem";
import TicketButton from "./TicketButton";

function TicketsPage({ role }) {
    const { t } = useTranslation();
    const { enqueueSnackbar } = useSnackbar();
    const [items, setItems] = useState([]);
    const [page, setPage] = useState(1);
    const [hasMore, setHasMore] = useState(true);
    const [loading, setLoading] = useState(false);
    const [initialLoad, setInitialLoad] = useState(true);

    const loginToken = localStorage.getItem('ACT');
    const config = {
        headers: {
            Accept: 'application/json',
            Authorization: `Bearer ${loginToken}`
        }
    };

    const loadData = async (page = 1, append = false) => {
        try {
            setLoading(true);

            const response = await axios.get(
                `${defaultVariables.url}/tickets/get-all-lists/${role}?page=${page}`,
                config
            );
            setItems((prev) => append ? [...prev, ...response.data.data] : response.data.data);
            setHasMore(response.data.data.length > 0);
        } catch (error) {
            enqueueSnackbar('Error fetching orders. Please try again.', { variant: 'error' });
            console.log(error.response)
        } finally {
            setLoading(false);
            setInitialLoad(false);

        }
    };

    useEffect(() => {
        scrollTop();
        loadData();
    }, []);


    const loadMore = () => {
        if (!loading && hasMore) {
            const nextPage = page + 1;
            setPage(nextPage);
            loadData(nextPage, true);
        }
    };
    const handleRefresh = () => {
        setPage(1);
        setHasMore(true);
        setInitialLoad(true);
        loadData();
    };
    return (
        <AppAnimate animation='transition.slideUpIn' delay={200} title={role !== 'admin' ? t('support') : t('ticketLists')}>
            <Grid container spacing={2} justifyContent="center">
                <Grid item size={12} className="flex-space">
                    <Title align="left" color="text" className="panel-title">
                        {role !== 'admin' ? t('support') : t('ticketLists')}
                        <Button
                            size="small"
                            color="primary"
                            startIcon={<RefreshCw />}
                            onClick={handleRefresh}
                            disabled={loading}
                            style={{marginRight:5}}
                        >
                            {t('refresh')}
                        </Button>
                    </Title>
                    {
                        role !== 'admin' &&  <TicketButton color="secondary" reload={handleRefresh}/>
                    }
                </Grid>
                {
                    initialLoad ? <ItemsSkeleton xs={12} md={12} lg={12} height={100}/> : (
                        <>
                            {
                                !!items.length &&

                                <Grid item size={12}>
                                    <InfiniteScroll
                                        dataLength={items.length}
                                        next={loadMore}
                                        hasMore={hasMore}
                                        loader={(
                                            <div style={{ textAlign: 'center', padding: '20px 0' }}>
                                                {loading && <CircularProgress />}
                                            </div>
                                        )}
                                    >
                                        <Grid container spacing={2}>
                                            {items.map((item, index) => (
                                                <Grid item size={{xs:12}} key={index}>
                                                    <SingleTicketListItem item={item} reload={handleRefresh} role={role}/>
                                                </Grid>
                                            ))}
                                        </Grid>
                                    </InfiniteScroll>
                                </Grid>
                            }
                            <Grid item size={12} style={{backgroundColor:"#f5f5f5", borderRadius:16}}>
                            {!initialLoad && items.length === 0  && !hasMore && (
                                <NothingFound
                                    type="page"
                                    title={t('noTicketFound')}
                                    title_color="text"
                                    paragraph={t('noTicketFoundDesc')}
                                    icon={<MessageSquareOff/>}
                                >
                                    <Button
                                        variant="outlined"
                                        startIcon={<ChevronLeft/>}
                                        component={Link}
                                        to={`/`}
                                    >
                                        {t('back')}
                                    </Button>
                                </NothingFound>
                            )}
                            </Grid>
                        </>
                    )
                }
            </Grid>
        </AppAnimate>
    );
}

export default TicketsPage;
